import React, { Component } from 'react'
import { connect } from 'react-redux'

import HeroUnitTitle from './hero-unit-title'
import HeroUnitVideo from './hero-unit-video'
import Filter from './filter'
import FeaturedPartner from './featured-partner'

import './hero-unit.scss'

class HeroUnit extends Component {

  render() {

    const { featuredPartners } = this.props
    return (
      <section className="app-hero-unit">
          <HeroUnitTitle />
          <HeroUnitVideo featuredPartners={featuredPartners} />
          <FeaturedPartner featuredPartners={featuredPartners} />
          <Filter 
            suggestionsIndustry={this.props.suggestionsIndustry}
            suggestionsLocation={this.props.suggestionsLocation} />
      </section>
    )
  }
}

export default connect(state => {
  const partnersWithVideos = state.firebase.data['companies'] ? 
        state.firebase.data['companies'].filter(partner => {
          return partner.videoUrl !== ''
        }) : []

  const randomIndices = new Array(3).fill().map(() => Math.round(Math.random() * partnersWithVideos.length))
  const featuredPartners = partnersWithVideos.filter((a, i) => {
    return randomIndices.find(a => a === i)
  })

  return { featuredPartners }
})(HeroUnit)



// WEBPACK FOOTER //
// ./src/components/hero-unit/index.jsx